/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMotorcyclePassenger32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <g stroke='currentColor' strokeMiterlimit={5} strokeWidth={1.5}>
        <path d='M13.5 27.453h4.959V10.241a1.38 1.38 0 00-1.38-1.38h-2.814M7.527 8.861H5a1.5 1.5 0 00-1.5 1.5v17.092h5' />
        <path d='M13.5 19.495A2.494 2.494 0 0011.005 17h-.01A2.494 2.494 0 008.5 19.495v9.006a2.5 2.5 0 005 0v-9.006 0z' />
        <path d='M25 27.5v1.049a2.5 2.5 0 005 0V27.5M18.998 27.453h11v-12.96-.001a7.555 7.555 0 00-11.296-.264l-.245.264' />
        <path d='M11 4c1.931 0 3.5 1.554 3.5 3.468C14.5 9.778 12.441 12 11 12c-1.703 0-3.5-2.222-3.5-4.532C7.5 5.554 9.069 4 11 4v0z' />
        <path d='M14.293 5.754l1.835-2.164a1.291 1.291 0 011.918-.06l3.247 3.372M7.5 5.647L5.665 3.483a1.293 1.293 0 00-1.917-.06L.5 6.795M9 22h4.5M21 17h6.5' />
      </g>
      <defs>
        <clipPath id='motorcycle-passenger-32_svg__clip0'>
          <path fill='#fff' d='M0 0h32v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgMotorcyclePassenger32;
